/**Deprecated */
import React from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import classNames from "classnames";

import ZigZagRow from "./ZigZagRow";

import "../styles/components/ZigZag.scss";

const ZigZag = ({ zigZagRows: rows, className }) => {
    if (!rows.length) {
        return null;
    }

    return (
        <div className={classNames("zig-zag", className)}>
            {rows.map(row => (
                <div
                    className={classNames("row-background", {
                        "bg-color": row.backgroundColor,
                        "bg-padding":
                            row.backgroundColor && !row.fullBleedMedia,
                    })}
                    style={{
                        backgroundColor: row.backgroundColor || "transparent",
                    }}
                    key={row.id}
                >
                    <ZigZagRow row={row} />
                </div>
            ))}
        </div>
    );
};

ZigZag.propTypes = {
    className: PropTypes.string,
    zigZagRows: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            copy: PropTypes.shape({
                raw: PropTypes.string,
                references: PropTypes.array,
            }),
            mediaFiles: PropTypes.arrayOf(
                PropTypes.shape({
                    title: PropTypes.string,
                    description: PropTypes.string,
                    mimeType: PropTypes.string,
                    gatsbyImageData: PropTypes.object,
                    file: PropTypes.shape({
                        contentType: PropTypes.string.isRequired,
                        url: PropTypes.string.isRequired,
                    }),
                }),
            ),
            embeddedMediaUrl: PropTypes.string,
            leftContent: PropTypes.string,
            className: PropTypes.string,
            backgroundColor: PropTypes.string,
            fullBleedMedia: PropTypes.bool,
        }),
    ),
};

export const query = graphql`
    fragment DynamicZigZag on ContentfulZigZag {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        takesFullPageWidth
        className
        zigZagRows {
            id
            copy {
                raw
                references {
                    ... on ContentfulButton {
                        __typename
                        contentful_id
                        label
                        color
                        url
                        openNewTab
                    }
                    ... on ContentfulForm {
                        __typename
                        contentful_id
                        formType
                        variant
                        lead {
                            raw
                        }
                        successMessage {
                            raw
                        }
                    }
                }
            }
            mediaFiles {
                mimeType
                file {
                    contentType
                    url
                }
                gatsbyImageData(layout: CONSTRAINED)
            }
            embeddedMediaUrl
            leftContent
            className
            backgroundColor
            fullBleedMedia
        }
    }
`;

export default ZigZag;
